export const pathConstants = {
  ROOT: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  USER_MANAGE: '/user-manage', // Admin create new user account
  MATCH_WORD_MEANING: '/match-word-meaning',
  RANDOM_TEAM: '/random-team',
  VOCAB_TEST_CREATE: '/vocab-test-create',
  FLASHCARD_PDF_CREATE: '/flashcard-pdf-create',
  FLASHCARD_MANAGE: '/flashcards', // Teacher/Admin flashcard management
  STUDENT_FLASHCARD: '/student/flashcards', // Student flashcard learning
  CLASSES_MANAGE: '/classes-manage',
  STUDENTS_MANAGE: '/students-manage',
  QUESTIONS_MANAGE: '/questions-manage',
  EXAMS_MANAGE: '/exams-manage',
  ATTENDANCE_MANAGE: '/attendance-manage',
  TUITION_MANAGE_NEW: '/tuition-manage-new',
  TUITION_STATISTICS: '/tuition-statistics',
  SCHEDULES_MANAGE: '/schedule-manage',
  LESSON_DIARY_MANAGE: '/lesson-diary-manage',
  STUDENT_PAGE: '/student', // page này là để học sinh login vào làm bài tập
  EXAM_PUBLIC: '/exam/:shareLink',
  CLAP_GAME: '/game/clap-game',
  REVIEW_MANAGE: '/review-manage',
  REVIEW_DETAIL: '/review/:id',
  STUDENT_REVIEW_LIST: '/student/reviews',
  SENTENCE_ORDER: '/teaching-mode/sentence-order',
  MULTIPLE_CHOICE: '/teaching-mode/multiple-choice',
  IELTS_PRACTICE: '/ielts-practice',
  BANK_ACCOUNT_MANAGE: '/bank-account-manage',
  STUDENT_PICKER: '/teaching-mode/student-picker',
  GIFT_MANAGE: '/teaching-mode/gift-manage',
};
